import { api } from '../../../configuration'
import { postRestRequest } from '../../../helpers/RestHelpers'
import { SimpleResult } from '../../types/PaginatedResult'

type SendMessageResponse = SimpleResult<boolean>

export type SendMessageParams = {
  data: {
    firstName: string
    lastName: string
    message: string
    email: string
    recipient: string
  }
}

const sendContact = (params: SendMessageParams) =>
  postRestRequest({
    url: `${api.REST_API_URL}/mail/sendContactForm`,
    headers: {
      'Content-Type': 'application/json',
      'Strapi-Response-Format': undefined,
    },
    data: params.data,
    transformer: (response: SendMessageResponse) => {
      return !!response.data
    },
  })

export default sendContact
